import React, { useState } from "react";
import "../styles/ZoomImageOverlayComponentStyle.css"; // For styling
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ZoomImageOverlay: React.FC = () => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [imageSrc, setImageSrc] = useState<string>("");

  const handleImageClick = (src: string) => {
    setImageSrc(src);
    setIsOverlayVisible(true);
  };

  const handleClose = () => {
    setIsOverlayVisible(false);
  };

  return (
    <div>
      {/* Example image - triggers the overlay when clicked */}
      <img
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
        alt="Thumbnail"
        className="thumbnail-image"
        onClick={() => handleImageClick("https://via.placeholder.com/600")}
      />

      {/* Overlay */}
      {isOverlayVisible && (
        <div className="overlay">
          <div className="overlay-content">
            <TransformWrapper
              limitToBounds={true}
              minScale={1}
              maxScale={3}
              centerOnInit={true}
              wheel={{
                step: 0.2, // Increase this value for faster zooming with the mouse wheel
              }}
              doubleClick={{
                mode: "reset",
              }}
              pinch={{
                step: 0.2, // Increase this value for faster zooming with pinch gestures
              }}
            >
              <TransformComponent>
                <img
                  src={imageSrc}
                  alt="Zoomed view"
                  className="overlay-image"
                />
              </TransformComponent>
            </TransformWrapper>
            <button className="close-button" onClick={handleClose}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZoomImageOverlay;
